import { toast } from "bulma-toast";
import * as yaml from 'js-yaml';
import * as React from 'react';
import * as CopyToClipboard from "react-copy-to-clipboard";
import { InjectedIntlProps, injectIntl } from "react-intl";
import { Prompt } from 'react-router';
import Profile from "src/models/Profile";
import { exportGeneratorToJson } from "src/utils/imUndExport";
import { shortenTo } from 'src/utils/stringManipulation';
import { preferredEditor, tooltips } from '../../../constants/profileSettings';
import { generatorWithoutID, saveNewGenerator, updateGenerator } from '../../../utils/api';
import GeneratorEntity from './../../../models/Generator';
import { validateWithoutID } from './../../../utils/api';
import CodeEditorComponent from './CodeEditorComponent';
import FormGeneratorComponent from './FormGeneratorComponent';
import translations from "./translations";


interface IProps extends InjectedIntlProps {
  generator: GeneratorEntity
  generators: GeneratorEntity[]
  id: string
  preferredEditor: preferredEditor
  theme: string
  loadGeneratorDetails: any,
  refreshGens: (callback?: any) => void,
  switchEditView: (view: string) => void
  updateGenerator: any
  profile: Profile
}

export interface IRunResult {
  htmlContent: string,
  textContent: string,
}
interface IState {
  appendResult: boolean
  askBeforeLeaving: boolean
  clipBoardText: string
  errorLine: number
  errorMessage: string
  isLoadingValidation: boolean
  isLoadingSaving: boolean
  isValidationError: boolean
  isYaml: boolean
  newID: string
  showRunView: boolean
  generatorResult: string
  content: string
  receivedUpdate: boolean
  syntaxError: boolean
  validated: boolean
  validateResult: string
  validationError: boolean
}

interface IValidateResult {
  htmlContent: string,
  htmlResult: string,
  result: string,
  textContent: string,
}


class EditGeneratorComponent extends React.Component<IProps, IState> {

  public constructor(props: IProps) {
    super(props);
    this.state = {
      appendResult: true,
      askBeforeLeaving: false,
      clipBoardText: '',
      content: 'Loading Data....',
      errorLine: 0,
      errorMessage: '',
      generatorResult: '',
      isLoadingSaving: false,
      isLoadingValidation: false,
      isValidationError: false,
      isYaml: true,
      newID: '',
      receivedUpdate: false,
      showRunView: false,
      syntaxError: false,
      validateResult: '',
      validated: true,
      validationError: false
    }
  }

  public componentDidMount() {
    setTimeout(() => {
      if (this.props.generators.length === 0) {
        this.props.refreshGens(() => {
          if (this.props.generator.id !== 'new' && this.props.generator.id !== '-1') {
            this.props.loadGeneratorDetails(this.props.generator.id)
          }
        })
      } else if (this.props.generator.id !== 'new' && this.props.generator.id !== '-1') {
        this.props.loadGeneratorDetails(this.props.generator.id)
      }
    }, 1000);
  }

  public setGen = () => {
    const temporaryGen = { ...this.props.generator }
    delete temporaryGen.id
    delete temporaryGen.hasAllData

    //  Clean Object
    for (const propName in temporaryGen) {
      if (temporaryGen[propName] === null || temporaryGen[propName] === undefined) {
        delete temporaryGen[propName];
      }
    }
    if (temporaryGen.tables !== undefined) {
      temporaryGen.tables.forEach((table: any) => {
        for (const propName in table) {
          if (table[propName] === null || table[propName] === undefined) {
            delete table[propName];
          }
        }
        if (table.entries !== undefined) {
          table.entries.forEach((entry: any, idx: number, arr: any[]) => {
            if (typeof entry === "string") {
              // entry = { m: 1, v: entry };
              // arr[idx] = entry;
            }
            else {
              for (const propName in entry) {
                if (entry[propName] === null || entry[propName] === undefined) {
                  delete entry[propName];
                }
              }
            }
          })
        }
      });
    }
    this.setState({
      ...this.state,
      content: yaml.dump(temporaryGen),
      receivedUpdate: true
    })
  }

  public toggleRunView = () => {
    this.setState({
      ...this.state,
      showRunView: !this.state.showRunView
    })
  }

  /**
   * * Run currently editing generator
   * @param code the code that needs to be run in JSON format
   */
  public runGenerator = (code: string) => {
    const result = generatorWithoutID(code)
    // const result = generatorWithoutID(yaml.load(this.state.content))
    if (result !== undefined) {
      result.then((data: IRunResult) => {
        if (data) {
          let output = data.htmlContent
          if (data.htmlContent.startsWith("<table>")) {
            output = data.htmlContent.replace("<table>", `<table class='table'>`)
          } else {
            output = '<div class="box">' + data.htmlContent + '</div>'
          }
          this.setState({
            ...this.state,
            clipBoardText: data.textContent + '\n' + this.state.clipBoardText,
            generatorResult: this.state.appendResult ? output + this.state.generatorResult : output,
          })

        }
      })
    }
  }
  public run = () => {
    this.runGenerator(yaml.load(this.state.content))
  }

  public validate = () => {
    this.setState({
      ...this.state,
      isLoadingValidation: true
    })
    const result = validateWithoutID(this.state.content)
    if (result) {
      result.then((data: IValidateResult) => {
        let isValid = false
        let validationError = true
        if (data !== undefined) {
          if (data.textContent === "[ALL OK]") {
            isValid = true
            validationError = false
          }
          this.setState({
            ...this.state,
            errorMessage: validationError ? data.htmlContent : '',
            isLoadingValidation: false,
            isValidationError: validationError,
            syntaxError: (validationError ? true : false),
            validateResult: data.htmlContent,
            validated: isValid,

          })

        } else {
          this.setState({
            ...this.state,
            isLoadingValidation: false,
          })
        }
        if (isValid) {
          toast({ message: this.props.intl.formatMessage(translations.validgenerator), type: "is-success", dismissible: "true", position: "top-right", opacity: "1", duration: 2500 })
        } else {
          this.setState({ ...this.state, isValidationError: true, validated: false })
          toast({ message: this.props.intl.formatMessage(translations.invalidgenerator), type: "is-danger", dismissible: "true", position: "top-right", opacity: "1", duration: 3500 })
        }

      })
    }
  }

  public contentChanged = (value: string) => {
    let err = false
    let line: number = 0
    let message: string = ''

    try {
      yaml.load(value);
    } catch (error) {
      err = true
      line = this.getErrorLine(String(error))
      message = error.message;
    }
    this.setState({
      ...this.state,
      askBeforeLeaving: true,
      content: value,
      errorLine: line,
      errorMessage: message,
      syntaxError: err,
      validated: false
    })
  }

  // Toggle JSON/Yaml
  public changeLang = () => {
    if (this.state.content.length === 0) {
      this.setState({
        ...this.state,
        content: (this.state.isYaml ? "{}" : ""),
        isYaml: false
      })
    } else if (this.state.isYaml) {
      this.setState({
        ...this.state,
        content: JSON.stringify(yaml.load(this.state.content), null, '\t'),
        isYaml: false
      })
    } else {
      try { // if the normal validation does not see an error but it is impossible to convertz to yaml, it throws an exception
        this.setState({
          ...this.state,
          content: (this.state.content === "{}" ? "" : (yaml.dump(JSON.parse(this.state.content)))), // If json only exists of "{}" make an empty yaml file
          isYaml: true
        })
      } catch (e) {
        this.setState({
          ...this.state,
          errorMessage: e,
          syntaxError: true,
          validated: false,
        })
      }
    }
  }


  public saveGenerator = () => {
    if (this.state.isValidationError) {
      this.validate()
      setTimeout(() => {
        if (!this.state.isValidationError) {
          this.saveGenerator()
        }
      }, 1000)
    } else if (!this.state.validated && this.state.isLoadingValidation === false && !this.state.syntaxError && !this.state.isValidationError) {
      this.validate()
      setTimeout(this.saveGenerator, 500)
    } else if (this.state.isLoadingValidation) {
      setTimeout(this.saveGenerator, 3000)
    } else if (this.state.validated) {
      this.setState({
        ...this.state,
        isLoadingSaving: true
      })
      const isNew = (this.props.id === "new" ? true : false)
      const generator: GeneratorEntity = yaml.load(this.state.content)
      if (isNew && this.state.newID?.length === 0) {
        const result = saveNewGenerator(generator)
        result.then((generators: GeneratorEntity[]) => {
          //  EROLG
          const savedGen = generators[0]
          this.setState({
            ...this.state,
            askBeforeLeaving: false,
            isLoadingSaving: false,
            newID: savedGen.id || '',
          })
          toast({ message: "Your new generator was succesfully stored on our servers", type: "is-success", dismissible: "true", position: "top-right", opacity: "1", duration: 3500 })
        })
      } else {
        if (this.props.generator.id === "new") {
          generator.id = this.state.newID
        } else {
          generator.id = this.props.generator.id
        }
        updateGenerator(generator).then(() => {
          this.setState({
            ...this.state,
            askBeforeLeaving: false,
            isLoadingSaving: false
          })
        })
        toast({ message: "Saved", type: "is-success", dismissible: "true", position: "top-right", opacity: "1" })
      }
    }
    this.props.refreshGens()
  }

  public closeIfApplicable = () => {
    if (this.state.showRunView) {
      this.setState({
        ...this.state,
        showRunView: false
      })
      // tslint:disable-line
    }
  }

  public downLoadJSON = () => {
    let obj = new GeneratorEntity()
    if (this.state.isYaml) {
      obj = {
        ...(yaml.safeLoad(this.state.content))
      }
    } else {
      obj = {
        ...JSON.parse(this.state.content)
      }
    }
    exportGeneratorToJson(obj)
  }

  public render() {
    return (
      <>
        <Prompt
          when={this.state.askBeforeLeaving}
          message={this.props.intl.formatMessage(translations.editorLeaveWarning)}
        />
        {/* <PreventNavigationDialog
          when={this.state.askBeforeLeaving}
          title="There are unsaved changes in the Document"
          message={<strong>Please save your changes</strong>}
        /> */}
        {/*
          Look into the profile settings and choose the preferred editor for the user.
          THe user can change these settings on the settings page *duh*
         */}
        {/* div className="wrapper" style={{ position: 'absolute',top:'0', left:'0', width:'100%', height:'100%', opacity:0.3, background:'#b3b3b3', textAlign:'center'}} */}
        <div onClick={this.closeIfApplicable} >
          {(this.props.preferredEditor === preferredEditor.formEditor)
            ? (
              <FormGeneratorComponent
                currentGen={yaml.load(this.state.content)}
                generator={this.props.generator}
                errorMessage={this.state.errorMessage}
                id={this.props.id}
                loadGeneratorDetails={this.props.loadGeneratorDetails}
                toggleRunView={this.toggleRunView}
                theme={this.props.theme}
                isLoadingValidation={this.state.isLoadingValidation}
                isShowingRunWindow={this.state.showRunView}
                changeLanguage={this.changeLang}
                contentChanged={this.contentChanged}
                receivedUpdate={this.state.receivedUpdate}
                refresh={this.props.refreshGens}
                runGenerator={this.runGenerator}
                validateGenerator={this.validate}
                setGen={this.setGen}
                saveGenerator={this.saveGenerator}
                switchView={this.props.switchEditView}
                syntaxError={this.state.syntaxError}
                validationError={this.state.validationError}
                validated={this.state.validated}
              />
            )
            : (
              <CodeEditorComponent
                content={this.state.content}
                errorMessage={this.state.errorMessage}
                generator={this.props.generator}
                id={this.props.id}
                isLoadingValidation={this.state.isLoadingValidation}
                isYaml={this.state.isYaml}
                isShowingRunWindow={this.state.showRunView}
                theme={this.props.theme}
                receivedUpdate={this.state.receivedUpdate}
                syntaxError={this.state.syntaxError}
                validated={this.state.validated}
                validationError={this.state.validationError}
                changeLanguage={this.changeLang}
                contentChanged={this.contentChanged}
                refresh={this.props.refreshGens}
                toggleRunView={this.toggleRunView}
                runGenerator={this.runGenerator}
                validateGenerator={this.validate}
                setGen={this.setGen}
                saveGenerator={this.saveGenerator}
                switchView={this.props.switchEditView}
                download={this.downLoadJSON}
              />
            )
          }
        </div>

        <div id="quickviewDefault" className={"quickview " + (this.state.showRunView ? 'is-active' : '')}>
          <header className="quickview-header">
            <span><b>{shortenTo(this.props.generator.name, 50)}</b></span>
            <span className="icon is-large has-text-danger" >
              <button className={this.props.profile.showTooltips === tooltips.on ? "button is-outlined is-danger tooltip is-tooltip-bottom" : 'button is-outlined is-danger'} data-tooltip={this.props.intl.formatMessage(translations.close)} onClick={this.toggleRunView} style={{ width: "50px" }}>X</button>
            </span>
          </header>

          <div className="quickview-body">
            <div className="quickview-block" dangerouslySetInnerHTML={{ __html: this.state.generatorResult }} />
          </div>

          <footer className="quickview-footer">
            <button className="button is-info is-primary" disabled={!this.state.validated} onClick={this.run}> {this.props.intl.formatMessage(translations.runGenerator)}</button>
            <button className="button is-dark " disabled={(this.state.generatorResult.length < 0)} onClick={this.clearRunResults}>{this.props.intl.formatMessage(translations.clear)}</button>
            <CopyToClipboard text={this.state.clipBoardText}>
              <a className={this.props.profile.showTooltips === tooltips.on ? "button is-dark tooltip is-tooltip-left" : 'button is-dark'} data-tooltip={this.props.intl.formatMessage(translations.copyToClipboard)} onClick={() => toast({ message: this.props.intl.formatMessage(translations.copiedToClipboard), type: "is-link", dismissible: "true", position: "top-right", opacity: "1", duration: "3500" })}> {/* tslint:disable-line */}
                <span className="icon" >
                  <i className="far fa-copy" />
                </span>
              </a>
            </CopyToClipboard>
          </footer>
        </div>
      </>
    );
  }

  private getErrorLine: any = (errMessage: string) => {
    let errorLine: any = -1;
    let a: any = errMessage.indexOf(" line");
    a = a + 6;
    let b: any = errMessage.indexOf("column ");
    b = b - 2;
    errorLine = errMessage.substring(a, b);
    return errorLine;
  }

  private clearRunResults = () => {
    this.setState({
      ...this.state,
      clipBoardText: '',
      generatorResult: ''
    })
  }
}

export default injectIntl(EditGeneratorComponent)



// WEBPACK FOOTER //
// ./src/Containers/generators/EditGenerator/EditGeneratorComponent.tsx